import '../../css/pages/page.story.less'
import VideoSlideshow from '../section/video-swiper.js'
(function () {
    function _isMobile() {
        let flag = navigator.userAgent.match(
            /(phone|pad|pod|iPhone|iPod|ios|iPad|Android|Mobile|BlackBerry|IEMobile|MQQBrowser|JUC|Fennec|wOSBrowser|BrowserNG|WebOS|Symbian|Windows Phone)/i
        );
        return flag;
    }
    function phoneCheck(){
        if(_isMobile()){
            $('body').removeClass('isPC').addClass('isMobile')
        }else{
            $('body').removeClass('isMobile').addClass('isPC')
        }
    }
    function hl() {
        $('#timeLine.MobileHide .rightFrame .point').removeClass('hl')
        $('#timeLine.MobileHide .rightFrame .point').removeClass('prehl')
        $('#timeLine.MobileHide .rightFrame .point').removeClass('preprehl')
        $('#timeLine.MobileHide .rightFrame .point').eq($('#timeLine.MobileHide .timeLineSwiper')[0].swiper.activeIndex).addClass('hl')
        if ($('#timeLine.MobileHide .timeLineSwiper')[0].swiper.activeIndex - 1 >= 0) {
            $('#timeLine.MobileHide .rightFrame .point').eq($('#timeLine.MobileHide .timeLineSwiper')[0].swiper.activeIndex - 1).addClass('prehl')
        }
        if ($('#timeLine.MobileHide .timeLineSwiper')[0].swiper.activeIndex + 1 < $('#timeLine.MobileHide .timeLineSwiper')[0].swiper.slides.length) {
            $('#timeLine.MobileHide .rightFrame .point').eq($('#timeLine.MobileHide .timeLineSwiper')[0].swiper.activeIndex + 1).addClass('prehl')
        }
        if ($('#timeLine.MobileHide .timeLineSwiper')[0].swiper.activeIndex - 2 >= 0) {
            $('#timeLine.MobileHide .rightFrame .point').eq($('#timeLine.MobileHide .timeLineSwiper')[0].swiper.activeIndex - 2).addClass('preprehl')
        }
        if ($('#timeLine.MobileHide .timeLineSwiper')[0].swiper.activeIndex + 2 < $('#timeLine.MobileHide .timeLineSwiper')[0].swiper.slides.length) {
            $('#timeLine.MobileHide .rightFrame .point').eq($('#timeLine.MobileHide .timeLineSwiper')[0].swiper.activeIndex + 2).addClass('preprehl')
        }
    }
    function popupDetail(i) {
        var popUp = $('<div class="popUpBg">' +
            '<div class="popUpFrame">' +
            '<div class="swiper popUpBigSwiper">' +
            '<div class="swiper-wrapper">' +
            (function () {
                var slide = ''
                $.each(storyData.timeLine[i].point, function (i2, v2) {
                    slide += '<div class="swiper-slide">' +
                        '<div class="popupPoint">' +
                        '<img data-src="' + v2.bigPic + '" class="popUpBigPic lazyload"/>' +
                        '<i class="iconfont jackery-icon-guanbi"></i>' +
                        '<div class="popUpLeft">' +
                        '<div class="popUpTitle">' + storyData.timeLine[i].year + '</div>' +
                        '<div class="popUpdesc">' + v2.text + '</div>' +
                        '</div>' +
                        '</div>' +
                        '</div>'
                })
                return slide
            })() +
            '</div>' +
            '<div class="swiper-pagination"></div>' +
            '</div>' +
            '<div class="swiper popUpSmallSwiper">' +
            '<div class="swiper-wrapper">' +
            (function () {
                var slide = ''
                $.each(storyData.timeLine[i].point, function (i2, v2) {
                    slide += `
                        <div class="swiper-slide">
                            <img data-src="${v2.smallPic}" class="popUpSmallPic lazyload"/>
                        </div>
                    `
                })
                return slide
            })() +
            '</div>' +

            '</div>' +
            '</div>' +
            '</div>').appendTo('#timeLine.MobileHide')
        popUp.find('.jackery-icon-guanbi').bind('click', function () {
            popUp.remove()
            window.timeLineSwiper.autoplay.start()
            $('body').removeClass('scrollLock')
        })

        var smallSwiper = new Swiper("#timeLine.MobileHide .popUpSmallSwiper", {
            slidesPerView: storyData.timeLine[i].point.length,
            freeMode: true,
            watchSlidesProgress: true
        })
        var bigSwiper = new Swiper("#timeLine.MobileHide .popUpBigSwiper", {
            slidesPerView: 1,
            effect: "fade",
            thumbs: {
                swiper: smallSwiper
            },
            pagination: {
                el: "#timeLine.MobileHide .popUpBigSwiper .swiper-pagination",
            }
        })
    }
    function popupPhoneDetail(i) {
        var popUp = $('<div class="popupMobile">' +
            '<div class="popupHead">' +
            '<div class="year">' + storyData.timeLine[i].year + '</div>' +
            '<i class="iconfont jackery-icon-guanbi"></i>' +
            '</div>' +
            (function () {
                var point = ''
                $.each(storyData.timeLine[i].point, function (i2, v2) {
                    point += `
                        <div class="desc">${v2.text}</div>
                        <img data-src="${v2.phonePic}" class="pic lazyload"/>
                    `
                    if (i2 !== storyData.timeLine[i].point.length - 1) {
                        point += '<div class="blank"></div>'
                    }
                })
                return point
            })() +
            '</div>').appendTo('#timeLine.PCHide')
        popUp.find('.jackery-icon-guanbi').bind('click', function () {
            popUp.remove()
            window.timeLinePhoneSwiper.autoplay.start()
            $('body').removeClass('scrollLock')
        })
    }
    window.onload = function () {

        phoneCheck()

        $.each(storyData.timeLine, function (i, v) {
            $('<div class="swiper-slide">' +
                '<div class="timeLinePoint">' +
                '<img data-src="' + v.bg + '" class="bgPic lazyload"/>' +
                '<div class="leftFrame">' +
                '<div class="title text-2xl font-bold">' + v.year + '</div>' +
                (function () {
                    var point = ''
                    $.each(v.point, (i2, v2) => point += `<div class="point text-sm font-400">${v2.text}</div>`)
                    return point
                })() +
                (v.point.length > 1 ? '<div class="more z-button-middle" i="' + i + '">' +
                    '<div class="text">' + window.locale_explore_more + '</div>' +
                    '<i class="iconfont jackery-icon-arrow-right"></i>' +
                    '</div>' : '') +
                '</div>' +
                '</div>' +
                '</div>').appendTo('#timeLine.MobileHide .swiper-wrapper')

            $('<div class="swiper-slide">' +
                '<img data-src="' + v.bgPhone + '" class="bgPic lazyload"/>' +
                '<div class="yearFrame">' +
                '<div class="title">' + v.year + '</div>' +
                (function () {
                    var point = ''
                    $.each(v.point, (i2, v2) => point += `<div class="desc">${v2.text}</div>`)
                    return point
                })() +
                '<div class="viewMoreButton" i="' + i + '">' +
                '<div class="viewMoreTitle">' + window.locale_view_more + '</div>' +
                '<i class="iconfont jackery-icon-arrowdown"></i>' +
                '</div>' +
                '</div>' +
                '</div>').appendTo('#timeLine.PCHide .swiper-wrapper')

            $('<div class="point"></div>').appendTo('#timeLine.PCHide .nav')
            $('<div class="point">' +
                '<div class="title">' + v.year + '</div>' +
                '<img src="' + v.bg + '" class="img"/>' +
                '</div>').appendTo('#timeLine.MobileHide .rightFrame')
        })
        $('#ourStory #solar .viewMoreButton.PCHide').unbind().bind('click', function () {
            $('#solar').toggleClass('hideText')
            $('#ourStory #solar .viewMoreButton.PCHide').toggleClass('active')
        })
        $('#ourStory #recognizedBy .viewMoreButton').unbind().bind('click', function () {
            $('#ourStory #recognizedBy').removeClass('listHide')
        })
        const timeLineSwiper = window.timeLineSwiper = new Swiper("#timeLine.MobileHide .timeLineSwiper", {
            direction: "vertical",
            slidesPerView: 1,
            spaceBetween: 30,
            effect: "fade",
            autoplay: {
                delay: 5000,
                stopOnLastSlide: false,
                disableOnInteraction: true,
            },
            on: {
                activeIndexChange: hl,
            }
        });

        $('#timeLine.MobileHide .rightFrame .point').each(function(i, v) {
            $(v).click(function(){
                window.timeLineSwiper.slideTo(i, 1000, true)
                window.timeLineSwiper.autoplay.start()
            })
        })


        hl()

        const timeLinePhoneSwiper = window.timeLinePhoneSwiper = new Swiper("#timeLine.PCHide .timeLineMobileSwiper", {
            direction: "vertical",
            slidesPerView: 1,
            spaceBetween: 30,
            effect: "fade",
            autoplay: {
                delay: 5000,
                stopOnLastSlide: false,
                disableOnInteraction: true,
            },
            allowTouchMove: false,
            on: {
                activeIndexChange: () => {
                    $('#timeLine.PCHide .nav .point').removeClass('hl')
                    $('#timeLine.PCHide .nav .point').eq(timeLinePhoneSwiper.activeIndex).addClass('hl')
                    if (storyData.timeLine[timeLinePhoneSwiper.activeIndex + 1]) {
                        $('.isMobile #ourStory #timeLine .nextFrame').show()
                        $('.isMobile #ourStory #timeLine .nextFrame .title').html(storyData.timeLine[timeLinePhoneSwiper.activeIndex + 1].year)
                    } else {
                        $('.isMobile #ourStory #timeLine .nextFrame').hide()
                    }
                }
            }
        });

        $(".isMobile #ourStory #timeLine .viewMoreButton").first().remove()
        $('#timeLine.PCHide .nav .point').eq(timeLinePhoneSwiper.activeIndex).addClass('hl')


        $('#timeLine.MobileHide .more').unbind().bind('click', function () {
            popupDetail(Number($(this).attr('i')))
            window.timeLineSwiper.autoplay.stop()
            $('body').addClass('scrollLock')
        })
        $('#timeLine.PCHide .viewMoreButton').unbind().bind('click', function () {
            popupPhoneDetail(Number($(this).attr('i')))
            window.timeLinePhoneSwiper.autoplay.stop()
            $('body').addClass('scrollLock')
        })

        $.each(storyData.certifcationsAndAwards.list, function (i, v) {
            $('<div class="point">' +
                '<img data-src="https://cdn.shopify.com/s/files/1/0550/0524/9633/files/2x_5cae98b9-5f46-4e04-839c-fcba051ee29f.png?v=1675060656" class="leftPic lazyload"/>' +
                '<div class="centerPoint">' +
                '<div class="pointNumber">' + v.num + '</div>' +
                '<div class="pointName">' + v.title + '</div>' +
                '<div class="pointName">' + v.title2 + '</div>' +
                '</div>' +
                '<img data-src="https://cdn.shopify.com/s/files/1/0550/0524/9633/files/2x_1.png?v=1675060701" class="rightPic lazyload"/>' +
                '</div>').appendTo('#certifcationsAndAwards .list')
        })
        $.each(storyData.certifcationsAndAwards.swiper, function (i, v) {
            $('<div class="swiper-slide">' +
                '<div class="swiperPoint">' +
                '<img class="pointImg lazyload" data-src="' + (_isMobile() ? v.picPhone : v.pic) + '"/>' +
                '<div class="pointTitle">' + v.title + '</div>' +
                '</div>' +
                '</div>').appendTo('#certifcationsAndAwards .swiper-wrapper')
        })
        new Swiper(".CertifcationsAndAwardsSwiper", {
            spaceBetween: 30,
            centeredSlides: true,
            slidesPerView: 'auto',
            loop: true,
            autoplay: true,
            navigation: {
                nextEl: ".CertifcationsAndAwardsSwiper .swiper-button-next",
                prevEl: ".CertifcationsAndAwardsSwiper .swiper-button-prev",
            },
            pagination: {
                el: ".CertifcationsAndAwardsSwiper .swiper-pagination",
                clickable: true,
            },
        });
        $.each(_isMobile ? storyData.recognizedBy.listPhone : storyData.recognizedBy.list, function (i, v) {
            $('<img data-src="' + v + '" class="lazyload ' + (function () {
                if (!i) {
                    if (_isMobile()) {
                        return 'veryBigPic PCHide'
                    } else {
                        return 'bigPic MobileHide'
                    }
                } else if (i <= 4) {
                    return 'bigPic'
                } else {
                    return 'pic'
                }
            })() + '"/>').appendTo('#recognizedBy .list')
        })

        new VideoSlideshow(document.querySelector(".video-slideshow"))
    }
    window.onresize = function () {
        phoneCheck()
    }
})()
